<template lang="pug">
b-modal#editBankAffiliate(
  ref="editBankAffiliate"
  :title="$t('ui.combine.edit_bank_affiliate')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="account_id"
        required
        alphaNum
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
        :maxLength="$v.account_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
    b-form-group(:label="$tc('ui.banks', 1)").mb-0
      BankLookup(
        ref="bank"
        size="sm"
        required
        type="array"
        :dirty="$v.bank.$dirty"
        :error="$v.bank.$error"
        v-model.trim.lazy="$v.bank.$model"
        :disabled="loading"
        status=true
        :category="category"
        :key="category"
      )
      ValidateResult(:value="$v.bank" :name="$tc('ui.banks', 1)")
    b-form-group(:label="$t('ui.bank_acc_no')").mb-0
      DebounceInput(
        size="sm"
        ref="bank_acc_no"
        required
        type="text"
        :dirty="$v.bank_acc_no.$dirty"
        :error="$v.bank_acc_no.$error"
        v-model.trim.lazy="$v.bank_acc_no.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_no" :name="$t('ui.bank_acc_no')")
    b-form-group(:label="$tc('ui.bank_acc_holder')").mb-0
      DebounceInput(
        size="sm"
        ref="bank_acc_holder"
        required
        type="text"
        :dirty="$v.bank_acc_holder.$dirty"
        :error="$v.bank_acc_holder.$error"
        v-model.trim.lazy="$v.bank_acc_holder.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.bank_acc_holder" :name="$t('ui.bank_acc_holder')")
    template(v-if="['ARS','AUD'].includes(getCurrencyCode)")
      b-form-group(:label="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          v-model.trim.lazy="$v.remark.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="['AUD'].includes(getCurrencyCode) ? $t('ui.bsb') : $t('ui.cuit')")
    template(v-if="['AUD'].includes(getCurrencyCode)")
      b-form-group(:label="$t('ui.payid')").mb-0
        DebounceInput(
          size="sm"
          type="text"
          :dirty="$v.remark_2.$dirty"
          :error="$v.remark_2.$error"
          v-model.trim.lazy="$v.remark_2.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark_2" :name="$t('ui.payid')")
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import BankLookup from "@/library/BankLookup";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    BankLookup,
  },
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      category: "",
      account_id: "",
      bank: "",
      bank_acc_no: "",
      bank_acc_holder: "",
      remark: "",
      remark_2: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  watch: {
    // category(newVal) {
    //   this.localCategory = newVal;
    // },
  },
  validations: {
    account_id: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(20)
    },
    bank: {
      required
    },
    bank_acc_no: {
      required,
      // integer,
      // minLength: minLength(6),
      // maxLength: maxLength(20)
    },
    bank_acc_holder: {
      required,
      // alphaNumWithSpace,
      // minLength: minLength(6),
      // maxLength: maxLength(50)
    },
    remark: {
      required: requiredIf(function () {
        return ['ARS','AUD'].includes(this.getCurrencyCode);
      }),
    },
    remark_2: {
      required: requiredIf(function () {
        return ['AUD'].includes(this.getCurrencyCode);
      }),
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankAccountEditAffUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          account_id: this.item.account_id,
          bank_id: this.item.bank_id.trim(),
          bank_acc_no: this.item.bank_acc_no.trim(),
          // bank_acc_holder: this.item.bank_acc_holder.trim(),
          new_bank_id: this.bank.split(' - ')[0].trim(),
          new_bank_acc_no: this.bank_acc_no.trim(),
          new_bank_acc_holder: this.bank_acc_holder.trim(),
          new_remark: this.remark.trim(),
          new_remark_2: this.remark_2.trim(),
          // bank_name: this.bank.split(' - ')[1].trim(),
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editBankAffiliate.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_bank_account", this.feedback.status);
                  this.$refs.editBankAffiliate.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.category = this.item.category;
      this.account_id = this.item.account_id;
      this.bank = this.item.bank_id.trim().toUpperCase() + ' - ' + this.item.bank_name.trim().toUpperCase();
      this.bank_acc_no = this.item.bank_acc_no;
      this.bank_acc_holder = this.item.bank_acc_holder;
      this.remark = this.item.remark;
      this.remark_2 = this.item.remark_2;
      this.$refs.bank_acc_holder.$el.focus();
    }
  }
};
</script>
